import * as React from 'react'

import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { PreviewVariants } from './typings'
import { IReferral } from '@sales-center/common'
import { Props as UpdateReferralProps } from '../../UpdateReferral'
import { TidalBillToCardBasic } from '@user/components/Location/BillToCardBasic'
import { DiscountCodeCardSmall } from '@user/components/DiscountCodes/DiscountCodeCardSmall/DiscountCodeCardSmall'
import { TidalEntityDetailsDiscountCodeCardSmall } from '@user/features/EntityDetails/components/TidalEntityDetailsDiscountCodeCardSmall'
import { Theme } from '@mui/material/styles'

type Props = Pick<
  UpdateReferralProps,
  'billToCardWidth' | 'billToCardMaxWidth'
> & {
  referral: IReferral
  variant: PreviewVariants
}

export function TidalCustomerPreview(props: Props) {
  const { referral, billToCardWidth, billToCardMaxWidth, variant } = props

  return (
    <Paper
      variant="outlined"
      sx={{
        backgroundColor: (theme: Theme) => theme.palette.background.default,
        border: 'solid 1px #e0e0e0',
        padding: (theme: Theme) => theme.spacing(1.5),
      }}
    >
      <Stack mb={2}>
        <Typography variant="subtitle2">Referral Type</Typography>
        <Typography variant="body2">Customer</Typography>
      </Stack>
      {variant === 'entityAdd' ? (
        <TidalEntityDetailsDiscountCodeCardSmall
          discountCodeId={referral.referralDiscountId}
        >
          {referral && referral.referralValue && (
            <TidalBillToCardBasic
              billToId={referral.referralValue}
              maxWidth={billToCardMaxWidth}
              width={billToCardWidth}
              viewOnly
            />
          )}
        </TidalEntityDetailsDiscountCodeCardSmall>
      ) : (
        <DiscountCodeCardSmall discountCodeId={referral.referralDiscountId} />
      )}
      {referral && referral.referralValue && variant !== 'entityAdd' && (
        <TidalBillToCardBasic
          billToId={referral.referralValue}
          maxWidth={billToCardMaxWidth}
          width={billToCardWidth}
        />
      )}
    </Paper>
  )
}
